import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import {
  permissionGroupDetailsFragment,
  permissionGroupFragment
} from "@saleor/fragments/permissionGroups";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  ExportGroupLogsFile,
  ExportGroupLogsFileVariables
} from "./types/ExportGroupLogsFile";
import {
  GroupActivityLogs,
  GroupActivityLogsVariables
} from "./types/GroupActivityLogs";
import {
  PermissionGroupDetails,
  PermissionGroupDetailsVariables
} from "./types/PermissionGroupDetails";
import {
  PermissionGroupList,
  PermissionGroupListVariables
} from "./types/PermissionGroupList";

export const permissionGroupListQuery = gql`
  ${pageInfoFragment}
  ${permissionGroupFragment}
  query PermissionGroupList(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filter: PermissionGroupFilterInput
    $sort: PermissionGroupSortingInput
  ) {
    permissionGroups(
      after: $after
      before: $before
      first: $first
      last: $last
      filter: $filter
      sortBy: $sort
    ) {
      edges {
        node {
          ...PermissionGroupFragment
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;
export const usePermissionGroupListQuery = makeQuery<
  PermissionGroupList,
  PermissionGroupListVariables
>(permissionGroupListQuery);

export const permissionGroupDetailsQuery = gql`
  ${permissionGroupDetailsFragment}
  query PermissionGroupDetails($id: ID!, $userId: ID!) {
    permissionGroup(id: $id) {
      ...PermissionGroupDetailsFragment
    }
    user(id: $userId) {
      editableGroups {
        id
      }
      userPermissions {
        code
        sourcePermissionGroups(userId: $userId) {
          id
        }
      }
    }
  }
`;
export const usePermissionGroupDetailsQuery = makeQuery<
  PermissionGroupDetails,
  PermissionGroupDetailsVariables
>(permissionGroupDetailsQuery);

export const groupActivityLogsQuery = gql`
  query GroupActivityLogs($first: Int) {
    groupActivityLogs(first: $first) {
      edges {
        node {
          id
          modelName
          action
          subject
          message
          newValues
          field
          oldValues
          createdAt
          updatedAt
          user {
            id
            firstName
            lastName
            email
          }
          group {
            smopUsertypeCode
          }
        }
      }
    }
  }
`;
export const useGroupActivityLogsQuery = makeQuery<
  GroupActivityLogs,
  GroupActivityLogsVariables
>(groupActivityLogsQuery);

export const exportGroupLogsFile = gql`
  query ExportGroupLogsFile($id: ID!) {
    exportFile(id: $id) {
      id
      status
      url
    }
  }
`;

export const useExportGroupLogsFile = makeQuery<
  ExportGroupLogsFile,
  ExportGroupLogsFileVariables
>(exportGroupLogsFile);
